import { _HasDataLoaderMeta } from 'unplugin-vue-router/runtime'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:all(.*)',
    name: '/[...all]',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/app',
    /* internal name: '/app' */
    /* no component */
    children: [
      {
        path: 'buyers-protection',
        name: '/app/buyers-protection',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/buyers-protection.vue'),
        /* no children */
      },
      {
        path: 'gun-management-system',
        name: '/app/gun-management-system',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/gun-management-system.vue'),
        /* no children */
      },
      {
        path: 'licencing',
        name: '/app/licencing',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/licencing.vue'),
        /* no children */
      },
      {
        path: 'premium',
        name: '/app/premium',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/premium.vue'),
        /* no children */
      },
      {
        path: 'privacy',
        name: '/app/privacy',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/privacy.vue'),
        /* no children */
      },
      {
        path: 'register-interest',
        name: '/app/register-interest',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/register-interest.vue'),
        /* no children */
      },
      {
        path: 'terms',
        name: '/app/terms',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/terms.vue'),
        /* no children */
      },
      {
        path: 'user-agreement',
        name: '/app/user-agreement',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/app/user-agreement.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auctions',
    name: '/auctions',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auctions.vue'),
    children: [
      {
        path: '',
        name: '/auctions/',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auctions/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/auctions/[id]',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auctions/[id].vue'),
        /* no children */
      },
      {
        path: 'invoice',
        /* internal name: '/auctions/invoice' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/auctions/invoice/[id]',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auctions/invoice/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/auth',
    name: '/auth',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth.vue'),
    children: [
      {
        path: '',
        name: '/auth/',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/index.vue'),
        /* no children */
      },
      {
        path: 'change-password',
        name: '/auth/change-password',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/change-password.vue'),
        /* no children */
      },
      {
        path: 'password-reset',
        name: '/auth/password-reset',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/password-reset.vue'),
        /* no children */
      },
      {
        path: 'setup',
        name: '/auth/setup',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/setup.vue'),
        children: [
          {
            path: '',
            name: '/auth/setup',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/setup/index.vue'),
            /* no children */
            meta: {
              "requiresAuth": true
            }
          },
          {
            path: 'dealer',
            name: '/auth/setup/dealer',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/setup/dealer.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "requiresDealerProfile": false
            }
          }
        ],
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'signup',
        name: '/auth/signup',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/signup.vue'),
        /* no children */
      },
      {
        path: 'verify',
        name: '/auth/verify',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/auth/verify.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dealers',
    name: '/dealers',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers.vue'),
    children: [
      {
        path: '',
        name: '/dealers/',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/index.vue'),
        children: [
          {
            path: '',
            name: '/dealers//',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/index/index.vue'),
            /* no children */
          },
          {
            path: 'gms',
            name: '/dealers//gms',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/index/gms.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "requiresDealerProfile": true
            }
          }
        ],
        meta: {
          "requiresAuth": true,
          "requiresDealerProfile": true
        }
      },
      {
        path: 'stock',
        name: '/dealers/stock',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/stock.vue'),
        children: [
          {
            path: '',
            name: '/dealers/stock/',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/stock/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/dealers/stock/[id]',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/stock/[id].vue'),
            /* no children */
          },
          {
            path: 'add',
            name: '/dealers/stock/add',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/stock/add.vue'),
            /* no children */
          },
          {
            path: 'import',
            name: '/dealers/stock/import',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/dealers/stock/import.vue'),
            /* no children */
          }
        ],
        meta: {
          "requiresAuth": true,
          "requiresDealerProfile": true
        }
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/guide',
    name: '/guide',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/guide.vue'),
    children: [
      {
        path: '',
        name: '/guide/',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/guide/index.vue'),
        /* no children */
      },
      {
        path: ':slug',
        name: '/guide/[slug]',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/guide/[slug].vue'),
        /* no children */
      }
    ],
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings.vue'),
    children: [
      {
        path: 'admin',
        name: '/settings/admin',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/admin.vue'),
        children: [
          {
            path: '',
            name: '/settings/admin/',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/admin/index.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "requiresAdmin": true
            }
          }
        ],
        meta: {
          "requiresAuth": true,
          "requiresAdmin": true
        }
      },
      {
        path: 'profile',
        name: '/settings/profile',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/profile.vue'),
        children: [
          {
            path: '',
            name: '/settings/profile/',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/profile/index.vue'),
            /* no children */
          },
          {
            path: 'approvals',
            name: '/settings/profile/approvals',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/profile/approvals.vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "requiresAdmin": true
            }
          },
          {
            path: 'bidding-summary',
            name: '/settings/profile/bidding-summary',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/profile/bidding-summary.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: '/settings/profile/settings',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/settings/profile/settings.vue'),
            /* no children */
          }
        ],
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/shop',
    /* internal name: '/shop' */
    /* no component */
    children: [
      {
        path: ':dealerSlug',
        /* internal name: '/shop/[dealerSlug]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/shop/[dealerSlug]/',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/shop/[dealerSlug]/index.vue'),
            /* no children */
          },
          {
            path: 'product',
            /* internal name: '/shop/[dealerSlug]/product' */
            /* no component */
            children: [
              {
                path: ':gunId',
                name: '/shop/[dealerSlug]/product/[gunId]',
                component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/shop/[dealerSlug]/product/[gunId].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/valuation',
    name: '/valuation',
    component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/valuation.vue'),
    children: [
      {
        path: '',
        name: '/valuation/',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/valuation/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/valuation/[id]',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/valuation/[id].vue'),
        /* no children */
      },
      {
        path: 'gun',
        /* internal name: '/valuation/gun' */
        /* no component */
        children: [
          {
            path: ':id',
            name: '/valuation/gun/[id]',
            component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/valuation/gun/[id].vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'guns',
        name: '/valuation/guns',
        component: () => import('/mnt/semics-code/code/gunauction/gunauction-front/src/pages/valuation/guns.vue'),
        /* no children */
      }
    ],
    meta: {
      "requiresAuth": false
    }
  }
]
